  document.addEventListener('DOMContentLoaded', function () {
    function getEmbedUrl(url) {
        if (!url) return null;

        var youtubeMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([a-zA-Z0-9_-]{6,})/);
        if (youtubeMatch) {
        return 'https://www.youtube.com/embed/' + youtubeMatch[1] + '?autoplay=1&playsinline=1';
        }

        var vimeoMatch = url.match(/vimeo\.com\/(?:.*\/)?(\d+)/);
        if (vimeoMatch) {
        return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
        }

        return null;
    }

    document.querySelectorAll('.u-video-block__media').forEach(function (media) {
        var overlay = media.querySelector('[data-video-overlay]');
        var holder = media.querySelector('[data-video-holder]');
        var video = holder ? holder.querySelector('video') : null;

        media.style.cursor = 'pointer';
        if (overlay) overlay.style.pointerEvents = 'auto';

        if (video) {
        video.removeAttribute('controls');
        video.controls = false;

        video.addEventListener('play', function () {
            if (overlay) overlay.classList.add('u-video-block__overlay--hidden');
        });
        ['pause', 'ended'].forEach(function (evt) {
            video.addEventListener(evt, function () {
            if (overlay) overlay.classList.remove('u-video-block__overlay--hidden');
            });
        });
        }

        media.addEventListener('click', function () {
        var iframe = holder ? holder.querySelector('iframe') : null;

        if (video) {
            if (video.paused) {
            video.play();
            } else {
            video.pause();
            }
        } else if (iframe) {
            iframe.remove();
            if (overlay) overlay.classList.remove('u-video-block__overlay--hidden');
        } else if (holder && holder.dataset.externalUrl) {
            var embedUrl = getEmbedUrl(holder.dataset.externalUrl);
            if (embedUrl) {
            var newIframe = document.createElement('iframe');
            newIframe.src = embedUrl;
            newIframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
            newIframe.setAttribute('allowfullscreen', '');
            holder.innerHTML = '';
            holder.appendChild(newIframe);
            }
            if (overlay) overlay.classList.add('u-video-block__overlay--hidden');
        }
        });
    });
});


// U Video Content

(function () {
function toggleVideo(e) {
    var video = e.target.closest('.u-vdocont-video');
    if (video) {
    video.paused ? video.play() : video.pause();
    return;
    }
    var btn = e.target.closest('.u-vdocont-play-btn');
    if (!btn) return;
    var wrap = btn.closest('.u-vdocont-video-wrap');
    if (!wrap) return;
    var vid = wrap.querySelector('.u-vdocont-video');
    if (vid) vid.play();
}

function setPlaying(isPlaying) {
    return function (e) {
    if (!e.target.classList || !e.target.classList.contains('u-vdocont-video')) return;
    var wrap = e.target.closest('.u-vdocont-video-wrap');
    if (wrap) wrap.classList.toggle('u-vdocont-is-playing', isPlaying);
    };
}

document.addEventListener('click', toggleVideo);
document.addEventListener('play', setPlaying(true), true);
document.addEventListener('pause', setPlaying(false), true);
document.addEventListener('ended', setPlaying(false), true);
})();
